import { fdrRecommendationProductImageCriteria } from 'fdr/components/util/criterias/recommendation-product-image.dmc';

export const fdrCommonPageComponentsVariables = {
  pageComponentsInput: { pagination: { page: 0, perPage: 100 } },
  productImageCriteria: fdrRecommendationProductImageCriteria,
};
